import { handleApiError, handleApiSuccess } from 'src/utils';

const UIStateActionTypes = {
  API_CALL_IN_PROGRESS: '[API] : Api call in progress.',
  API_CALL_SUCCESS: '[API] : Api call resolved successfully.',
  API_CALL_FAILED: '[API] : Api call errored.',

  UI_ROUTE_CHANGED: '[UI] : UI route changed.',

  INVALID_PAGE_PERMISSION: '[UI] : User does not have valid page level permission.',

  CRITICAL_DATA_ABSENT: '[UI] : Critical data for the page is not present.',

  SHOW_SUCCESS_BANNER: '[UI] : Show success banner.',
  SHOW_ERROR_BANNER: '[UI] : Show error banner.',

  SHOW_MESSAGE: '[UI] : Show UI messages.',
  RESET_UI_STATE: '[UI] : Reset UI State',
};

export function ShowUIMessageAction(payload) {
  return {
    type: UIStateActionTypes.SHOW_MESSAGE,
    payload,
  };
}

function ApiCallInProgress(payload) {
  return {
    type: UIStateActionTypes.API_CALL_IN_PROGRESS,
    payload,
  };
}

function ApiCallSuccessAction(payload) {
  return {
    type: UIStateActionTypes.API_CALL_SUCCESS,
    payload,
  };
}

function ApiCallFailedAction(payload) {
  return {
    type: UIStateActionTypes.API_CALL_FAILED,
    payload,
  };
}

function UIRouteChangeAction(payload) {
  return {
    type: UIStateActionTypes.UI_ROUTE_CHANGED,
    payload,
  };
}

function InvalidPagePermissionAction(payload) {
  return {
    type: UIStateActionTypes.INVALID_PAGE_PERMISSION,
    payload,
  };
}

function CriticalDataNotPresent(payload) {
  return {
    type: UIStateActionTypes.CRITICAL_DATA_ABSENT,
    payload,
  };
}

function ResetUIState() {
  return {
    type: UIStateActionTypes.RESET_UI_STATE,
    payload: null,
  };
}

function ShowSuccessBanner(payload) {
  return async dispatch => {
    dispatch(ApiCallSuccessAction(handleApiSuccess({}, payload)));
    return true;
  };
}

function ShowErrorBanner(payload) {
  return async dispatch => {
    dispatch(ApiCallFailedAction(handleApiError({}, payload)));
    return true;
  };
}

export {
  UIStateActionTypes,
  ApiCallSuccessAction,
  ApiCallFailedAction,
  ApiCallInProgress,
  UIRouteChangeAction,
  InvalidPagePermissionAction,
  CriticalDataNotPresent,
  ShowSuccessBanner,
  ShowErrorBanner,
  ResetUIState,
};
